import { RevisionDisplayMode } from '../models/revisionDisplayMode.js';

export function isPlayerProgressBarBlocked(lessonPlanController, isBlockVisited) {
	const { selectedSlideIndex, slideNavigationMap, mode, lessonPlanContents } = lessonPlanController;

	const selectedSlide = slideNavigationMap[selectedSlideIndex];
	const isSlideCompleted = selectedSlide.completion;

	const isViewMode = mode === RevisionDisplayMode.view;
	const isActivityMode = mode === RevisionDisplayMode.activity;

	const isNavigationSequential = lessonPlanContents.settings.styles.navigation.locked;

	const urlPathname = window.location.pathname;
	const isDraft = urlPathname.includes('draft');

	if (isBlockVisited || isSlideCompleted) return false;

	if (isViewMode) return isNavigationSequential || !isDraft;
	
	if (isActivityMode) return true;

	return false;
}
